import { Box, Container } from '@hausgold/designsystem';
import React from 'react';
import PressLogos from './PressLogos';
import Link from './Link';

const KnownFrom = () => (
  <Container px="2">
    <Box
      display={{ base: 'block', md: 'inline-block' }}
      my={{ base: 5, md: 0 }}
      mt={{ base: 4, md: 0 }}
      textAlign={{ base: 'center', md: 'left' }}
      textColor="gray.400"
    >
      Bekannt aus
      <sup>
        <Link
          to="#press-release-dates"
          eventLabel="1"
          eventParams={{ element_type: 'KnownFrom' }}
        >
          1
        </Link>
      </sup>
      :
    </Box>
    <PressLogos showReviews />
  </Container>
);

export default KnownFrom;
